import {
  TableOfContentsProps as MantineTableOfContentsProps,
  TableOfContents as MantineTableOfContents,
} from '@mantine/core';

export type TableOfContentsProps = MantineTableOfContentsProps;

export const TableOfContents = MantineTableOfContents;

TableOfContents.displayName = 'TableOfContents';
